import { TableRow } from '@material-ui/core';
import styled from 'styled-components';

export const TableRowContainer = styled(TableRow)`
  td {
    padding: 0px !important;
  }
`;
